import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { throwError } from 'rxjs';
import { map, filter, take, withLatestFrom, switchMap, catchError } from 'rxjs/operators';

import { buildBreadcrumbsUseCase } from '../use-cases/build-breadcrumbs.use-case';

import { InitBreadcrumbs, InitBreadcrumbsSuccess } from './breadcrumbs.actions';

import { getHomeConfig } from '@core/infrastructure/state/core.selectors';
import { CategoriesSelectors } from '@features/category';

@Injectable()
export class BreadcrumbsEffects {
    constructor(
        private readonly actions$: Actions,
        private readonly store: Store,
    ) {}

    private readonly getCategoriesNavigation$ = this.store.select(CategoriesSelectors.getCategoriesNavigation);

    public initBreadcrumbs$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(InitBreadcrumbs),
            withLatestFrom(
                this.getCategoriesNavigation$,
            ),
            switchMap(([action, categoriesNavigation ]) => {
                return this.store.select(getHomeConfig).pipe(
                    map(config => config.slice(0, 2)), // Recuperamos solamente MEN y WOMEN (Excluimos BG)
                    filter(config => config.every(item => item.locationPath !== '')), // Esperamos a que todos los elementos tengan locationPath
                    take(1),
                    map((homeConfig) => {
                        const breadcrumbs = buildBreadcrumbsUseCase(
                            action.categoryId,
                            action?.product,
                            categoriesNavigation,
                            homeConfig
                        );
                        return InitBreadcrumbsSuccess({ breadcrumbs: breadcrumbs });
                    }),
                    catchError((error: unknown) => {
                        return throwError(() => error);
                    })
                );
            })
        );
    });
}
